module.exports = __webpack_public_path__ + "static/img/kids-img-03@m.71f71c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/kids-img-03@m.jpg
// module id = loiF
// module chunks = 0